import { Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { MenuItem } from 'interfaces/generic';
import {
  TAdvancedSelectedMarkets,
  TMarketType,
  TSelectedMarketTypeNames
} from 'interfaces/sportsbook';
import { AdvancedMarketsFilterSkeleton } from './Skeleton';
import './index.less';

const { AdvancedMarketsFilterContent } = lazy(
  () =>
    import(
      /* webpackChunkName: "advanced-markets-filter-content" */ './Content'
    )
);

type TAdvancedMarketsFilterProps = {
  marketTypes: TMarketType[] | null;
  selectedMarketsReduxKey: string;
  selectedMarkets?: TAdvancedSelectedMarkets;
  selectedMarketTypeNames?: TSelectedMarketTypeNames;
  selectedSport?: MenuItem | null | undefined;
  addSportSectionInHeader?: boolean;
  doNotShowMarkerFiltersRow?: boolean;
};

export const AdvancedMarketsFilter = ({
  marketTypes,
  selectedMarkets,
  selectedMarketsReduxKey,
  selectedMarketTypeNames,
  selectedSport,
  addSportSectionInHeader,
  doNotShowMarkerFiltersRow
}: TAdvancedMarketsFilterProps) => {
  return marketTypes && selectedMarkets && selectedMarketsReduxKey ? (
    <Suspense
      fallback={
        <AdvancedMarketsFilterSkeleton
          addSportSectionInHeader={addSportSectionInHeader}
        />
      }
    >
      <AdvancedMarketsFilterContent
        marketTypes={marketTypes}
        selectedMarkets={selectedMarkets}
        selectedMarketsReduxKey={selectedMarketsReduxKey}
        selectedMarketTypeNames={selectedMarketTypeNames}
        selectedSport={selectedSport}
        addSportSectionInHeader={addSportSectionInHeader}
        doNotShowMarkerFiltersRow={doNotShowMarkerFiltersRow}
      />
    </Suspense>
  ) : (
    <AdvancedMarketsFilterSkeleton
      addSportSectionInHeader={addSportSectionInHeader}
    />
  );
};
